module.exports = require("@swa-ui/placements/src/BannerWithCard/BannerWithCardLayout2.module.scss");